import React from 'react'

import { useRouterScrollToTop } from '@domain-group/react-hooks'

import useCurrentUser from '@hooks/useCurrentUser'
import useFlipperKey from '@hooks/useFlipperKey'
import useIntercom from '@hooks/useIntercom'
import useServices from '@hooks/useServices'

interface AdminProps {
  children: React.ReactNode,
}

const Admin = (props: AdminProps) => {
  const { children } = props

  const { isEnabled } = useFlipperKey('intercom')
  const { isBrandUser, isProviderUser } = useCurrentUser()

  const hideWidget = isEnabled ? !(isBrandUser || isProviderUser) : true

  useIntercom({ hideWidget })

  useServices({ performHttpRequests: true })

  // Scroll Page to top when route changes
  useRouterScrollToTop()

  return children
}

export default Admin
